import type {SocialAccount} from '@Components/social-media/account.vo';
import type {PlatformMediaType} from '@Components/social-media/post.vo';
import type {SocialPostPublishingAction} from '@Components/social-media/publish-params.types';

export interface PublishingPostProps {
  account: SocialAccount;
  publishingAction: SocialPostPublishingAction;
  platformMediaType?: PlatformMediaType;
}

export const USER_WAITING_MESSAGE_DELAY_MS = 30000;
